export default {
  surtitle: {
    id: 'sourcing_page_content_banner_surtitle',
    defaultMessage: 'Allo?',
  },
  emptyOrdersTitle: {
    id: 'sourcing_page_content_banner_empty_orders_title',
    defaultMessage: 'You don’t have new orders',
  },
  emptyTitle: {
    id: 'sourcing_page_content_banner_empty_title',
    defaultMessage: 'There’s nothing here',
  },
  description: {
    id: 'sourcing_page_content_banner_description',
    defaultMessage:
      'We’ve looked everywhere but there’s no orders with these filters.',
  },
  searchButton: {
    id: 'sourcing_page_content_banner_search_button',
    defaultMessage: 'Search in all orders',
  },
}
